<script lang="ts">
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  import type { ActionProps } from "./ActionSlotProps";
  import { useHintAndValidationMessage } from "./utils/useHintAndValidationMessage.svelte";
  import { useOcAuto } from "./utils/useOcAuto.svelte";
  import { useMaskedLink } from "./utils/useMaskedLink.svelte";

  let {
    Host,
    children = undefined,
    actionState = $bindable({
      active: false,
      checked: false,
      disabled: false,
      hover: false,
      invalid: false,
      placeholderShown: false,
    }),
  }: ActionProps = $props();

  const getActionElement = (): HTMLElement | undefined =>
    Array.from(Host.children).find((e): e is HTMLElement => e.slot === "");

  /*                                                                           */
  let actionElement = $state<HTMLElement | undefined>(getActionElement());

  /*                                                                                                             */
  useHintAndValidationMessage(Host, () => actionElement);

  /**
 *
 */
  const update = (): void => {
    if (!actionElement) return;

    const style = getComputedStyle(actionElement);
    const getFlag = (p: string): boolean => style.getPropertyValue(p) !== "0";

    Object.assign(actionState, {
      active: getFlag("--active"),
      checked: getFlag("--checked"),
      disabled: getFlag("--disabled"),
      hover: getFlag("--hover"),
      invalid: getFlag("--invalid"),
      placeholderShown: getFlag("--placeholder-shown"),
    });
  };

  /*                                                        */
  $effect(() => actionElement && update());

  /*                                                     */
  useMaskedLink(() => actionElement);

  /*                                                                  */
  useOcAuto(Host, () => actionElement);
</script>

<svelte:element
  this={"slot"}
  class="action-slot"
  ontransitionstart={update}
  data-oc-floating-focus-v1-target
  onslotchange={getActionElement}>{@render children?.()}</svelte:element
>

<style lang="scss" global>
  /*                                                 */
  @use "sass:math";

  .action-slot {
    /*                                                                 */
    /*                                                                */
    &::slotted(input),
    &::slotted(button),
    &::slotted(textarea),
    &::slotted(select),
    &::slotted(a) {
      background: transparent;
      border: 0;
      padding: 0;
      margin: 0;
      outline: none;
      appearance: none;
      text-decoration: none;
      font: inherit;
      color: inherit;
      --oc-floating-focus-v1-full-bleed: "";
    }

    /*                                                                         */
    &::slotted(:empty) {
      pointer-events: auto;
      position: absolute;
      inset: 0;
    }

    /*                                                                    */
    &::slotted(:enabled) {
      cursor: pointer;
    }

    &::slotted(:disabled) {
      cursor: not-allowed;
    }

    &::slotted(*) {
      box-sizing: border-box;

      /*                                                            */
      --active: 0;
      --checked: 0;
      --disabled: 0;
      --hover: 0;
      --invalid: 0;
      --placeholder-shown: 0;
      box-shadow: 0 0 0 0
        rgba(
          /*                                                                   */
          calc(
              var(--active) + var(--checked) + var(--disabled) + var(--hover) + var(--invalid) +
                var(--placeholder-shown)
            ),
          0,
          0,
          0
        ) !important;
      transition: box-shadow 1ms !important;
    }

    /*                                               */
    &::slotted(:active) {
      --active: #{math.pow(2, 0)};
    }

    &::slotted(:checked),
    &::slotted([aria-checked="true"]) {
      --checked: #{math.pow(2, 1)};
    }

    &::slotted(:disabled),
    &::slotted([aria-disabled="true"]) {
      --disabled: #{math.pow(2, 2)};
    }

    &::slotted(:user-invalid),
    &::slotted([aria-invalid="true"]) {
      --invalid: #{math.pow(2, 3)};
    }

    &::slotted(:placeholder-shown) {
      --placeholder-shown: #{math.pow(2, 4)};
    }
  }

  @media (hover: hover) {
    /*                                                                                  */
    :host(:hover) > .action-slot,
    :hover .action-slot {
      &::slotted(*) {
        --hover: #{math.pow(2, 5)};
      }
    }
  }

  /*                                                               */
  ::slotted(label[for]) {
    position: relative;
    pointer-events: auto;
  }
</style>
